import { defaultStatus } from '@/_schemas/status-input';
import type { RouteListItem } from '@/types';

import { type PreferredRelationsShipsFormSchema } from './schemas';

import { settingsBcLink } from '../../model';

export const defaultValues = {
  name: '',
  status: defaultStatus,
} as PreferredRelationsShipsFormSchema;

export const breadcrumbsLinks: RouteListItem[] = [
  settingsBcLink,
  { path: '/settings/preferred-relationships', name: 'Preferred Relationships' },
];
